import { useOrganisationQuery } from 'front-end/src/public-api/hooks/useOrganisation.codegen'
import { apolloClientPublic } from 'front-end/src/graphql/apolloClient'

export function useOrganisation() {
  return useOrganisationQuery({
    client: apolloClientPublic,
    fetchPolicy: 'cache-first'
  })
}
